import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { localeResolver } from '@core/resolvers/locale.resolver';
import { applicationResolver } from './application.resolver';
import { ApplyPageComponent } from './apply-page/apply-page.component';
import { ApplyModule } from './apply.module';

@NgModule({
  imports: [
    ApplyModule,
    RouterModule.forChild([{
      path: ':applicationId/forms/:formId',
      component: ApplyPageComponent,
      resolve: {
        locale: localeResolver,
        application: applicationResolver
      },
      data: {
        namespace: ['APPLY', 'search', 'addOrg'],
        pageName: 'Application Landing Page'
      }
    }])
  ]
})
export class ApplicationRoutingModule { }
